import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgControlNumberPlusDisabled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 28 28"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle stroke="#E8E8E8" cx={14} cy={14} r={13.5} />
        <path
          d="M18.5 12.88h-3.38V9.5a.75.75 0 00-.74-.75h-.76a.75.75 0 00-.74.75v3.38H9.5a.75.75 0 00-.75.74v.76c0 .4.34.74.75.74h3.38v3.38c0 .41.33.75.74.75h.76c.4 0 .74-.34.74-.75v-3.38h3.38c.41 0 .75-.33.75-.74v-.76a.75.75 0 00-.75-.74z"
          fill="#CCC"
        />
      </g>
    </svg>
  );
}

SvgControlNumberPlusDisabled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgControlNumberPlusDisabled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgControlNumberPlusDisabled svgRef={ref} {...props} />
));
export default ForwardRef;
